import type { PlaybookContentGuidePreview } from "../../state/api.types";
import { useDocumentTitle } from "../../utilities/useDocumentTitle";
import { PlaybookDocsCard } from "./PlaybookDocsCard";
import { PlaybookFilterLayout } from "./PlaybookFilterLayout";
import { PlaybookSearchHero } from "./PlaybookSearchHero";
import { PlaybookSection } from "./PlaybookSection";
import { PlaybookSidebarGuides } from "./PlaybookSidebarGuides";
import { useFilteredPlaybookContentOverview } from "./hooks";
import { PlaybookSectionSkeleton } from "./skeletons";

export const PlaybookPage = () => {
  useDocumentTitle("Playbook");

  const { data, isLoading } = useFilteredPlaybookContentOverview();

  const guidesBySection = (data?.guides ?? []).reduce<
    Record<string, PlaybookContentGuidePreview[]>
  >((acc, guide) => {
    (acc[guide.section] ??= []).push(guide);
    return acc;
  }, {});

  const sections = (data?.sections ?? [])
    .map((section) => ({
      section,
      guides: guidesBySection[section.slug] ?? [],
    }))
    .filter(({ guides }) => guides.length > 0);

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col">
      <PlaybookSearchHero />
      <PlaybookFilterLayout
        heading={
          <h2 className="text-display-sm leading-7 font-semibold text-primary">
            Guides
          </h2>
        }
        sidebar={
          <>
            <PlaybookDocsCard />
            <PlaybookSidebarGuides />
          </>
        }
      >
        <div className="flex flex-col gap-6xl">
          {isLoading
            ? Array.from({ length: 3 }).map((_, i) => (
                <PlaybookSectionSkeleton key={i} />
              ))
            : sections.map(({ section, guides }) => (
                <PlaybookSection
                  key={section.slug}
                  section={section}
                  guides={guides}
                />
              ))}
        </div>
      </PlaybookFilterLayout>
    </div>
  );
};
